import React from "react";
import styled from "styled-components";
import Label from "./Label";
import { errorStyles } from "./styles";

export const InputFieldContainer = styled.div`
  width: 100%;
  vertical-align: top;
`;
InputFieldContainer.displayName = "InputFieldContainer";

export const formatOrData = (formatter, data) =>
  formatter ? formatter(data) : data;

const InputElement = styled.input`
  ${errorStyles}
  width: 100%;
  display: block;
  font-family: ${(props) => props.theme.fonts.heading};
  font-weight: ${(props) => props.theme.fonts.weights.normal};
  font-size: 16px;
  padding: 15px;
  height: 48px;
  border-radius: initial;
  line-height: 1.5em;
`;
const InputField = ({
  id,
  invalidText,
  error = true,
  visible = true,
  disabled,
  required,
  text,
  data,
  onChange,
  formatter,
  type = "text",
}) => {
  return visible ? (
    <InputFieldContainer id={id} visible={visible}>
      <Label
        fontSize="12px"
        transform="uppercase"
        error={!error}
        marginVertical="8px"
        disabled={disabled}
      >
        {text} {required && <sup>*</sup>}
      </Label>
      <InputElement
        type={type}
        error={error}
        name={id}
        value={formatOrData(formatter, data)}
        raw={data}
        onChange={onChange}
        disabled={disabled}
      />
      {!error && (
        <Label weight="500" error marginVertical="8px">
          {invalidText}
        </Label>
      )}
    </InputFieldContainer>
  ) : null;
};
InputField.displayName = "InputField";

export default InputField;
